import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {NGXLogger} from 'ngx-logger';
import {Observable, of as observableOf} from 'rxjs';

import {catchError} from 'rxjs/operators';
import {SensorType} from '../model/sensor-type.model';
import {SensorTypeService} from '../service/sensor-type.service';

@Injectable()
export class SensorTypeResolver {

  constructor(private deviceService: SensorTypeService,
              private logger: NGXLogger,
              private router: Router) {
    this.logger.debug('SensorTypeResolver constructing.');
  }

  resolve(): Observable<SensorType[]> {
    this.logger.debug('SensorTypeResolver retrieve all sensorTypes');
    return this.deviceService.getAllSensorTypes().pipe(catchError((error) => {
      if (error === 404) {
        this.router.navigate(['404']);
      } else {
        this.router.navigate(['error']);
      }
      return observableOf(null);
    }));

  }

}
